import { WsPlaceholderToTopic, WsTopicPlaceholder } from '../../types'

export const fillTopic = <T extends WsTopicPlaceholder>(
  topicPlaceholder: T,
  props: { [key in string]: string },
) =>
  Object.keys(props).reduce(
    (acc, key) => acc.replace(`$${key}`, props[key]),
    topicPlaceholder,
  ) as WsPlaceholderToTopic<T>
